export default {
  setData (state, payload) {
    state.userInfo = payload
  },
  setLog (state, payload) {
    state.logData = payload
  }
}
